document.addEventListener('DOMContentLoaded', function () {
  function handleMenuClick(e) {
    const link = e.target.closest('.mobile-menu .link-container summary a');
    if (!link) return;

    e.preventDefault();

    const details = link.closest('details');
    if (details) {
      details.open = true;
      details.classList.add('menu-opening');
    }
  }

  document.addEventListener('click', handleMenuClick);

  // Hantera theme editor reload
  document.addEventListener('shopify:section:load', function () {
    // Event delegation behöver ingen re-init
  });
});
